import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-annotation', 'open', 'Atidaryti anotaciją');
Labels.set('ui-annotation', 'close', 'Uždaryti anotaciją');
